import { c as _c } from "react/compiler-runtime";
import type { IconType } from "react-icons";
import { RiBankCardLine, RiBriefcaseLine, RiCustomerService2Line, RiNurseLine, RiStethoscopeLine } from "react-icons/ri";
import type { TrainingPersona } from "@/types/training";
const ICONS: Record<TrainingPersona, IconType> = {
  FRONT_DESK: RiCustomerService2Line,
  PROVIDER: RiStethoscopeLine,
  NURSE: RiNurseLine,
  BILLING: RiBankCardLine,
  OWNER: RiBriefcaseLine
};
export function PersonaIcon(t0) {
  const $ = _c(3);
  const {
    persona,
    className
  } = t0;
  const Icon = ICONS[persona];
  let t1;
  if ($[0] !== Icon || $[1] !== className) {
    t1 = <Icon className={className} aria-hidden="true" />;
    $[0] = Icon;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}